export default "__VITE_PUBLIC_ASSET__d1547d3f__"